import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import CheckoutService from '@/services/checkout.service';
import { store } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutClearData',
  setup(__props) {

function fetchBasket() : void {
    store.dispatch('basket/fetchBasket');
}

onMounted(() => {
    CheckoutService.clearCheckoutData();
    // force a reload of the basket from server
    fetchBasket();
});

return { __sfc: true,fetchBasket }
}

})